import React, {
  useImperativeHandle,
  forwardRef,
  useState,
  useEffect,
  useRef,
} from 'react'
import PrimeModal from '@/components/primeModal'
import { Form, Select, Radio, Input, App } from 'antd'
import { useTranslation } from 'react-i18next'
import { queryDictVersion, dictInsert, queryDomain, insertVersion, insertDict, queryKnowledgeVersion, knowledgeDirectoryInsert } from '@/api/dictionary'
import { useSearchParams } from 'react-router-dom'

enum CreateMethod {
  Inherit = '1',
  CreateNew = '2',
}

interface AddVersionProps {
  onStart?: () => void
  onSuccess?: () => void
  operationType?: number // 1-新建字典 2-新建版本
  type?: 'dict' | 'knowledge'
}

const AddVersion = ({ onSuccess, type = 'dict', onStart }: AddVersionProps, ref: any) => {
  const { message } = App.useApp()
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [versionLoading, setVersionLoading] = useState(true)
  const [createMethod, setCreateMethod] = useState<any>('')
  const [form] = Form.useForm()
  const [dictNames, setDictNames] = useState([])
  const [popFromType, setPopFromType] = useState(1)
  const [dictTypes, setDicTypes] = useState([])
  const [dictVersions, setDictVersions] = useState([])
  const dictsRef = useRef(null)
  const [moduleType, setModuleType] = useState('')
  const [dictType, setDictType] = useState('')

  // const onDictNameChange = (val: any) => {
  //   const versions = (dictsRef.current as any).find(
  //     (item: any) => item.dictName === val
  //   ).versionList
  //   setDictVersions(
  //     versions.map((item: any) => {
  //       return {
  //         label: item.version,
  //         value: item.dictId,
  //       }
  //     })
  //   )
  //   form.setFieldValue('dictId', undefined)
  // }

  const fetchDictVersion = async (dictName: string) => {
    let res: any = []
    if (type === 'knowledge') {
      res = await queryKnowledgeVersion()
    } else {
      res = await queryDictVersion()
    }
    const versions = res.find(
      (item: any) => item.dictName === dictName
    )?.versionList || []

    setDictVersions(
      versions.map((item: any) => {
        return {
          label: item.version,
          value: item.dictId,
        }
      })
    )
    setVersionLoading(false)
  }

  const fetchDicts = async () => {
    const res: any = await queryDictVersion()
    dictsRef.current = res
    setDictNames(
      res.map((item: any) => {
        return {
          label: item.dictName,
          value: item.dictName,
        }
      })
    )
  }

  const fetchDictType = async () => {
    const res: any = await queryDomain({ type: 3 })
    const targetDomainList = res?.find(n=>n.moduleType === moduleType)?.domainList || []
    setDicTypes(
      targetDomainList.map((item: any) => {
        return {
          label: item.domainName,
          value: item.id,
        }
      }) || []
    )
  }


  const open = (record: any) => {
    setPopFromType(record.popFromType)
    fetchDictVersion(record.dictName)
    form.setFieldsValue(record)
    setVisible(true)
    setModuleType(record.moduleType)
    setDictType(record.dictType)
  }
  const close = () => {
    form.resetFields()
    setVisible(false)
  }
  useImperativeHandle(ref, () => ({
    open,
    close,
  }))

  useEffect(() => {
    if (!visible || !moduleType) return
    fetchDictType()
  }, [visible, moduleType])

  const onFinish = async (values: any) => {
    try {
      onStart && onStart()
      setLoading(true)
      if (type === 'knowledge') {
        if (popFromType === 2) {
          await insertDict({ ...values, moduleType })
        } else {
          await knowledgeDirectoryInsert(values)
        }
      } else if (type === 'dict') {
        if (popFromType === 2) {
          await insertVersion({ ...values, moduleType })
        } else {
          await insertDict({ ...values, moduleType,dictType })
        }
      }
      message.success(t('ikg.success', { action: t('dict.addVersion') }))
      close()
      setLoading(false)
      typeof onSuccess === 'function' && onSuccess()
    } catch (error) {
      setLoading(false)
    }
  }

  const form1 = () => <>
    <Form.Item
      label={t('dict.dictName')} // 字典名称
      name="dictName"
      rules={[
        {
          required: true,
          message: t('ikg.select', { name: t('dict.dictName') }),
        },
      ]}
    >
      <Input placeholder={t('ikg.input', { name: t('dict.dictName') })} />
    </Form.Item>
    <Form.Item
      label={t('dict.dictType')} // 字典域名
      name="domainId"
      rules={[
        {
          required: true,
          message: t('ikg.select', { name: t('dict.dictType') }),
        },
      ]}
    >
      <Select
        placeholder={t('ikg.select', { name: t('dict.dictType') })}
        options={dictTypes}
      // onChange={onDictNameChange}
      />
    </Form.Item>
    {/* 创建版本号 */}
    <Form.Item
      label={t('dict.versionNo')}
      name="version"
      rules={[
        {
          required: true,
          message: t('ikg.input', { name: t('dict.versionNo') }),
        },
      ]}
    >
      <Input placeholder={t('ikg.input', { name: t('dict.versionNo') })} />
    </Form.Item>
    <Form.Item label={t('dict.desc')} name="desc">
      <Input.TextArea
        placeholder={t('ikg.input', { name: t('dict.desc') })}
        maxLength={300}
        showCount
        rows={4}
      />
    </Form.Item>
  </>

  const form2 = () => <>
    <Form.Item
      label={t('dict.dictName')} // 字典名称
      name="dictName"
      rules={[
        {
          required: false,
          message: t('ikg.select', { name: t('dict.dictName') }),
        },
      ]}
    >
      <Input placeholder={t('ikg.input', { name: t('dict.dictName') })} disabled={true} />
    </Form.Item>
    <Form.Item
      label={t('dict.inheritVersion')} // 继承版本
      name="inheritDictId"
      rules={[
        {
          required: false,
          message: t('ikg.select', {
            name: t('dict.inheritVersion'),
          }),
        },
      ]}
    >
      <Select
        loading={versionLoading}
        placeholder={t('ikg.select', {
          name: t('dict.inheritVersion'),
        })}
        allowClear
        options={dictVersions}
      />
    </Form.Item>
    {/* 创建版本号 */}
    <Form.Item
      label={t('dict.versionNo')}
      name="version"
      rules={[
        {
          required: true,
          message: t('ikg.input', { name: t('dict.versionNo') }),
        },
      ]}
    >
      <Input placeholder={t('ikg.input', { name: t('dict.versionNo') })} />
    </Form.Item>
    <Form.Item label={t('dict.desc')} name="desc">
      <Input.TextArea
        placeholder={t('ikg.input', { name: t('dict.desc') })}
        maxLength={300}
        showCount
        rows={4}
      />
    </Form.Item>
  </>

  const form3 = () => <>
    <Form.Item
      label={t('knowledge.txt20')}
      name="name"
      rules={[
        {
          required: false,
          message: t('ikg.input', { name: t('knowledge.txt20') }),
        },
      ]}
    >
      <Input placeholder={t('ikg.input', { name: t('knowledge.txt20') })} />
    </Form.Item>
    <Form.Item
      label='code'
      name="code"
      rules={[
        {
          required: false,
          message: t('ikg.input', { name: 'code' }),
        },
      ]}
    >
      <Input placeholder={t('ikg.input', { name: 'code' })} />
    </Form.Item>
  </>

  return (
    <PrimeModal
      title={popFromType === 1 ? t('dict.addDirSingle') : t('dict.addDirVersion')}
      open={visible}
      onCancel={close}
      onOk={() => form.submit()}
      okButtonProps={{
        loading,
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
      >
        {/* 创建方式 */}
        {/* <Form.Item
          label={t('dict.createMethod')}
          name="type"
          rules={[
            {
              required: true,
              message: t('ikg.select', { name: t('dict.createMethod') }),
            },
          ]}
        >
          <Radio.Group
            onChange={(e) => {
              setCreateMethod(e.target.value)
            }}
          >
            <Radio value={CreateMethod.Inherit}>{t('dict.inherit')}</Radio>
            <Radio value={CreateMethod.CreateNew}>{t('dict.createNew')}</Radio>
          </Radio.Group>
        </Form.Item> */}
        {/* {createMethod === CreateMethod.CreateNew && (
          <div style={{ padding: 16, background: '#FAFBFB' }}>
            <Form.Item
              label={t('dict.dictName')} // 字典名称
              name="dictName"
              rules={[
                {
                  required: true,
                  message: t('ikg.input', { name: t('dict.dictName') }),
                },
              ]}
            >
              <Input
                placeholder={t('ikg.input', { name: t('dict.dictName') })}
              />
            </Form.Item>
          </div>
        )}
        {createMethod === CreateMethod.Inherit && (
          <div style={{ padding: 16, background: '#FAFBFB' }}>
            <Form.Item
              label={t('dict.dictName')} // 字典名称
              name="dictName"
              rules={[
                {
                  required: true,
                  message: t('ikg.select', { name: t('dict.dictName') }),
                },
              ]}
            >
              <Select
                placeholder={t('ikg.select', { name: t('dict.dictName') })}
                options={dictNames}
                onChange={onDictNameChange}
              />
            </Form.Item>
            <Form.Item
              label={t('dict.inheritVersion')} // 继承版本
              name="dictId"
              rules={[
                {
                  required: true,
                  message: t('ikg.select', {
                    name: t('dict.inheritVersion'),
                  }),
                },
              ]}
            >
              <Select
                placeholder={t('ikg.select', {
                  name: t('dict.inheritVersion'),
                })}
                options={dictVersions}
              />
            </Form.Item>
          </div>
        )} */}
        {
          popFromType === 1 ? form1() :
            popFromType === 2 ? form2() : form3()
        }
        <Form.Item hidden name="domainId">
          <Input />
        </Form.Item>
        <Form.Item hidden name="dictId">
          <Input />
        </Form.Item>
      </Form>
    </PrimeModal>
  )
}

export default forwardRef(AddVersion)
